import axios from "axios";
import { SECRETS } from "./secrets";

export const axiosInstance = axios.create({
  baseURL: SECRETS.API_URL,
  withCredentials: true,
});

export const whisperAxiosInstance = axios.create({
  baseURL: SECRETS.WHISPER_API_PATH,
  withCredentials: true,
});

export const llamaAxiosInstance = axios.create({
  baseURL: SECRETS.LLAMA_API_PATH,
  withCredentials: true,
});
